/**
*
* DateTimeString
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { calendar, parseISO } from 'utils/date-fns/index.js';

function DateTimeString(props) {
  const { date, className, short } = props;
  try {
    return (
      <span className={className}>{calendar(typeof date === 'string' ? parseISO(date) : date, short)}</span>
    );
  } catch (error) {
    error.info = { component: 'DateTimeString', value: date, type: typeof end, isDate: date instanceof Date, className, short };
    throw error;
  }
}

DateTimeString.propTypes = {
  date: PropTypes.any.isRequired,
  short: PropTypes.bool,
  className: PropTypes.string,
};

export default DateTimeString;
